import config from '@/config';
import {ApiBase, InternationalizedField} from '@/api/common';
import SentenceLink from '@/api/sentenceLink';
import Hint from "@/api/hint";
import VideosI18n from "@/api/videos-i18n";
import LessonVideoInfo from "@/api/lessonVideoInfo";
import ExtraLine from "@/api/extraLine";

const NO_UPLOAD_FIELDS = [
    'audio_link',
    'audio_alt_link',
    'extra_lines_objects',
];

export default class ConversationContent extends ApiBase<ConversationContent> {
    public static readonly SLUG: string = 'exercise-conversation-content';
    private static readonly URL_BASE: string = config.API_ROOT + '/exercise-conversation-content/';
    
    // Initializing these fields (even with undefined)
    // is necessary, so hasOwnAttribute can find them.
    public audio_path?: number = undefined;
    public audio_link?: string = undefined;
    public audio_alt_path?: number = undefined;
    public audio_alt_link?: string = undefined;
    public sentence_links?: SentenceLink[] = [];
    public sentence?: string = undefined;
    public parent_exercise?: number = undefined;
    public icon_id?: string = undefined;
    public image_path?: number = undefined;
    public image_link?: string = undefined;
    public transcription?: string = undefined;
    public lesson_video: LessonVideoInfo = undefined;
    public lesson_video_list: LessonVideoInfo[] = [];
    public extra_lines?: number[] = [];
    public extra_lines_objects?: ExtraLine[] = [];

    // currently unused
    public spreadsheet?: string = undefined;
    public sentence_i18n: InternationalizedField<string> = new InternationalizedField<string>();

    public constructor() {
        super({
            urlBase: ConversationContent.URL_BASE,
            filteredFields: NO_UPLOAD_FIELDS,
        });
    }
    
    public assign(response: any): ConversationContent {
        super.assign(response);
         if (response) {
             if ('sentence_i18n' in response) {
                 this.sentence_i18n = new InternationalizedField<string>(response.sentence_i18n);
             }
             if ('lesson_video' in response) {
                this.lesson_video_list = [];
                this.lesson_video_list.push(new LessonVideoInfo().assign(response.lesson_video));
             }
             if ('extra_lines' in response) {
                this.extra_lines = undefined;
                response.extra_lines.forEach((extra_line: any) => {
                    this.extra_lines_objects.push(new ExtraLine().assign(extra_line));
                });
            }
         }
        return this;
    }

    public async save(): Promise<number> {
        await this.saveLessonVideoInfo();
        if (!this.id) {
            return await super.save();
        } else {
            await Promise.all([
                this.saveExtraLines(),
            ]);

            return await super.save();
        }
    }

    public async saveExtraLines() {
        for (const extra_line of this.extra_lines_objects) {
            if (extra_line.state !== 'deleted') {
                extra_line.parent_model = 'exerciseconversationcontent';
                extra_line.parent_id = this.id;
                if (!this.extra_lines) {
                    this.extra_lines = [];
                }
                this.extra_lines.push(extra_line.id);
            } else if (extra_line.state === 'deleted' && extra_line.id) {
                await extra_line.delete();
            }
        }
    }

    public async saveLessonVideoInfo(){
        if (this.lesson_video_list && this.lesson_video_list.length >= 1) {
            if (!this.id) {
                return delete this.lesson_video;
            } else {
                this.lesson_video = this.lesson_video_list[0];
            }
        }
    }

}
